<div class="maintenance-popup">
  <div class="popup-container">
    <div class="popup-header">
      <h2 class="popup-title">{{ title }}</h2>
      <button class="close-btn" (click)="onClose()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="popup-body">
      <div class="popup-message" [innerHTML]="message"></div>
    </div>

    <div class="popup-footer">
      <button class="ok-btn" (click)="onClose()">
        OK
      </button>
    </div>
  </div>
</div>